import { render } from "./HistoricalDataBooks.vue?vue&type=template&id=513c2f9e&scoped=true"
import script from "./HistoricalDataBooks.vue?vue&type=script&lang=js"
export * from "./HistoricalDataBooks.vue?vue&type=script&lang=js"

import "./HistoricalDataBooks.vue?vue&type=style&index=0&id=513c2f9e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513c2f9e"]])

export default __exports__